import { gql } from '@apollo/client'

export const CREATE_FILE_ARCHIVE_MUTATION = gql`
  mutation createFileArchive($signedIds: [String!]!, $filename: String) {
    createFileArchive(signedIds: $signedIds, filename: $filename) {
      url
      errors
    }
  }
`
